import { render, staticRenderFns } from "./CrashDetail.vue?vue&type=template&id=3a96a05a&scoped=true"
import script from "./CrashDetail.vue?vue&type=script&lang=js"
export * from "./CrashDetail.vue?vue&type=script&lang=js"
import style0 from "./CrashDetail.vue?vue&type=style&index=0&id=3a96a05a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a96a05a",
  null
  
)

export default component.exports